<script>
    import { locale , t } from '../i18n/i18n';
    import { code } from '../store.js'

    export let lang;

    function changeLocale() {
        $locale = lang;
        gtag('event', 'ag_lang', {
            'code': $code.replace('Z1AG1','Z0AG1') + $t('audio.suffix'),
        });
    }
</script>

<div class='lang-button' on:click={changeLocale} on:keypress={()=>{}}>
    <img src="./assets/images/lang_button_{lang}{$locale == lang?'_selected':''}.png" alt/>
    <div class='button-text'><slot/></div>
</div>

<style lang="scss">
    .lang-button{
        width: 27%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        aspect-ratio: 17 / 8;

        img {
            width: 100%;
            position: absolute;
            height: auto;
            z-index: -1;
            object-fit: contain;
        }

        .button-text {
            color: white;
            padding-right: 3%;
            padding-bottom: 3%;
        }
    }

    @media screen and (min-width:550px){
        .lang-button{
            width: unset;
            height: 60px;
        }
    }
</style>
